module.exports = __webpack_public_path__ + "static/media/frustrert.79a6c169.m4a";